export default {
    already_unlocked: 'already_unlocked',
    nothing_to_pay: 'nothing_to_pay',
    pay_to_unlock: 'pay_to_unlock',

    isPayable(unlockInfo) {
        return unlockInfo === this.pay_to_unlock
    }
}